export const TypesCarregaGate = {
    CARREGAGATE: "CARREGAGATE",
    RESETCARREGAGATE: "RESETCARREGAGATE",
    LACRECARREGAMENTO: "LACRECARREGAMENTO",
    EMPILHADEIRA: "EMPILHADEIRA",
    LOCALCARREGAMENTO: "LOCALCARREGAMENTO"
}

const INITIAL = {
    programacaoId: 0,
    gateDetalhe: [],
    lacreCarregamento: '',
    empilhadeira: -1,
    localCarregamento: -1
}

export default function carregaGateReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesCarregaGate.CARREGAGATE:
            return {
                ...state,
                programacaoId: action.payload.gateId
            };
        case TypesCarregaGate.LACRECARREGAMENTO:
            return {
                ...state,
                lacreCarregamento: action.payload.lacreCarregamento
            };
        case TypesCarregaGate.EMPILHADEIRA:
            return {
                ...state,
                empilhadeira: action.payload.empilhadeira
            };
        case TypesCarregaGate.LOCALCARREGAMENTO:
            return {
                ...state,
                localCarregamento: action.payload.localCarregamento
            };
        case TypesCarregaGate.RESETCARREGAGATE:
            return INITIAL;
        default:
            return state;
    }
}

export const CarregaGateActions = {
    carregaGate,
    resetStateCarregaGate,
    setLacreCarregamento,
    setEmpilhadeira,
    setLocalCarregamento
}

function carregaGate(pgateId) {

    return {
        type: TypesCarregaGate.CARREGAGATE,
        payload: { gateId: pgateId }
    }
}

function setLacreCarregamento(lacre) {

    return {
        type: TypesCarregaGate.LACRECARREGAMENTO,
        payload: { lacreCarregamento: lacre }
    }
}

function setEmpilhadeira(emp) {

    return {
        type: TypesCarregaGate.EMPILHADEIRA,
        payload: { empilhadeira: emp }
    }
}

function setLocalCarregamento(local) {

    return {
        type: TypesCarregaGate.LOCALCARREGAMENTO,
        payload: { localCarregamento: local }
    }
}

function resetStateCarregaGate() {
    return { type: "RESETCARREGAGATE" }
}